var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"my-container"},[_c('el-header',[_c('HeadBar')],1),_c('el-container',[_c('el-main',[_c('AppMain')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }